import { handleResult, postForm } from '../http';
import confirmDialog from '../dialogs/confirm-dialog';

// Article/Index: archive and unarchive. Rows hold `archived` and `status` and ask with:
//   $dispatch('article-request', { id, name, row: $data })
// The controller maps archive to POST /article/activate and unarchive to /article/deactivate.
export const articleDialog = () => ({
  ...confirmDialog(),

  ask({ id, name, row }) {
    const archive = !row.archived;

    this.show({
      title: `${archive ? 'Archive' : 'Unarchive'} this article?`,
      name,
      message: archive ? 'will be archived.' : 'will be unarchived.',
      confirmLabel: archive ? 'Archive' : 'Unarchive',
      tone: archive ? 'danger' : 'primary',
      action: async () => {
        const response = await postForm(`/article/${archive ? 'activate' : 'deactivate'}`, { articleId: id });
        handleResult(response, (data) => {
          row.archived = archive;
          row.status = data.articleStatus;
        });
      },
    });
  },
});
